export { Modal as ModalNext } from './Modal.js';
// Modal control
export { ModalProvider as ModalNextProvider } from './ModalProvider/ModalProvider.js';
export { useModal } from './Modal.hooks.js';
export { InternalModalContext } from './context.js';
export { modalNextTheme } from './theme.js';
// Modal Layout
export { ModalLayout, ModalCard, ModalHeader, ModalTitle, ModalContent, ModalFooter, ModalCloseIcon, modalLayoutTheme, } from './ModalLayout/index.js';
if (window?.location.hostname.includes('localhost') ||
    window?.location.hostname.includes('staging')) {
    console.warn('Old Modal is deprecated and will be removed in the future. Please use Modal from @clds/modal instead.');
}
